export enum HostType {
    MASTER = 'MASTER',
    SEGMENT = 'SEGMENT',
}

interface TextProps {
    blacklist: string[];
    regexp: string;
    min: string;
    max: string;
}

export enum DiskSize {
    DISK_SIZES = 'diskSizes',
    DISK_SIZE_RANGE = 'diskSizeRange',
}

interface RawDiskTypeBase {
    diskTypeId: string;
    minHosts: string;
    maxHosts: string;
    hostCountDivider: string;
    maxSegmentInHostCount: string;
}

interface RawDiskTypeSizes extends RawDiskTypeBase {
    diskSizes: {
        sizes: string[];
    };
    DiskSize: DiskSize.DISK_SIZES;
}

interface RawDiskTypeSizeRange extends RawDiskTypeBase {
    diskSizeRange: {
        min: string;
        max: string;
    };
    DiskSize: DiskSize.DISK_SIZE_RANGE;
}

interface RawHost {
    resourcePresets: RawResourcePreset[];
    type: HostType;
    defaultResources: {
        resourcePresetId: string;
        diskTypeId: string;
        diskSize: string;
        generation: string;
        generationName: string;
    };
}

type RawPresetZoneDisk = RawDiskTypeSizes | RawDiskTypeSizeRange;

interface RawResourcePreset {
    zones: {
        diskTypes: RawPresetZoneDisk[];
        zoneId: string;
    }[];
    presetId: string;
    cpuLimit: string;
    memoryLimit: string;
    generation: string;
    generationName: string;
    type: string;
    cpuFraction: string;
    decomissioning: boolean;
}

export interface RawGreenplumConfig {
    hostTypes: RawHost[];
    versions: string[];
    availableVersions: {
        updatableTo: string[];
        id: string;
        name: string;
        deprecated: boolean;
    }[];
    clusterName: TextProps;
    defaultVersion: string;
    userName: TextProps;
    password: TextProps;
    defaultZoneId: string;
}
